"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeasonStatus = void 0;
var SeasonStatus;
(function (SeasonStatus) {
    SeasonStatus["Inactive"] = "Inactive";
    SeasonStatus["Planning"] = "Planning";
    SeasonStatus["Active"] = "Active";
    SeasonStatus["OnHold"] = "On Hold";
    SeasonStatus["Completed"] = "Completed";
})(SeasonStatus = exports.SeasonStatus || (exports.SeasonStatus = {}));
//# sourceMappingURL=season-status.js.map